// src/component/Moderation/Badge/Badge.tsx
import React from 'react';
import './Badge.scss';

type Variant = 'default' | 'success' | 'danger' | 'warning' | 'info';

type Props = {
  text: string;
  variant?: Variant;
  className?: string;
  title?: string;
};

export const Badge: React.FC<Props> = ({ text, variant = 'default', className = '', title }) => {
  return (
    <span className={`ui-badge ui-badge--${variant} ${className}`} title={title}>
      {text}
    </span>
  );
};
